import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaSolicitudes from './TablaSolicitudes';

const Solicitudes: React.FC = () => (
  <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
    <TablaSolicitudes />
  </Box>
);

export default Solicitudes;
